import { DismissBackground1nezyx9ss0e1b as DismissBackground } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/DismissBackground.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../components/nav/AppDimensions.mjs';
import { DialogSemantic_getInstance3cqn6ufjbbrs2 as DialogSemantic_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { get_centered1xfu6or5nc0lq as get_centered } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  Frame1e7t2kcdb3wu7 as Frame,
  RowOrCol3a33s3yce2tuv as RowOrCol,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../components/nav/crowpay.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { ViewWriter2xfqkrnuqv5cx as ViewWriter } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/ViewWriter.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { sizeConstraints2hv7x4j4qpd36 as sizeConstraints } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  title1nssp3ryhwuqj as title,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
} from '../theming/Titles.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { Align_Start_getInstance25tw14h3otx5g as Align_Start_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { align1ejncrrer3meh as align } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
} from '../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function dialogView(_this__u8e3s4, content) {
  // Inline function 'com.crowpay.views.components.dismissBackground2' call
  // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (DismissBackground())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.tbo(dialogView$slambda_0());
  view.eba(get_AppDimensions().wg1_1);
  var tmp = view.ibb(view.hbb(DialogSemantic_getInstance()), get_centered(view));
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (Frame())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.eba(get_AppDimensions().wg1_1);
  content(view_0);
  view.fbb(p_0, view_0);
  view.jbb(tmp, view_0);
  _this__u8e3s4.fbb(p, view);
  return view;
}
function *_generator_invoke__zhh2q8($this, $completion) {
  var tmp = $this.uic_1.agh_1($this.vic_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var tmp = $this.wic_1.agh_1($this.xic_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var GenericDialog$_init_$slambda_w7jzu5Class;
function GenericDialog$_init_$slambda_w7jzu5() {
  if (GenericDialog$_init_$slambda_w7jzu5Class === VOID) {
    class $ {
      wgg(_this__u8e3s4, $completion) {
        get_dialogStack().ngd();
      }
      s2(p1, $completion) {
        return this.wgg(p1 instanceof ViewWriter() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    GenericDialog$_init_$slambda_w7jzu5Class = $;
  }
  return GenericDialog$_init_$slambda_w7jzu5Class;
}
function GenericDialog$_init_$slambda_w7jzu5_0() {
  var i = new (GenericDialog$_init_$slambda_w7jzu5())();
  var l = (_this__u8e3s4, $completion) => i.wgg(_this__u8e3s4, $completion);
  l.$arity = 1;
  return l;
}
var GenericDialog$_init_$slambda_w7jzu5Class_0;
function GenericDialog$_init_$slambda_w7jzu5_1() {
  if (GenericDialog$_init_$slambda_w7jzu5Class_0 === VOID) {
    class $ {
      wgg(_this__u8e3s4, $completion) {
        get_dialogStack().ngd();
      }
      s2(p1, $completion) {
        return this.wgg(p1 instanceof ViewWriter() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    GenericDialog$_init_$slambda_w7jzu5Class_0 = $;
  }
  return GenericDialog$_init_$slambda_w7jzu5Class_0;
}
function GenericDialog$_init_$slambda_w7jzu5_2() {
  var i = new (GenericDialog$_init_$slambda_w7jzu5_1())();
  var l = (_this__u8e3s4, $completion) => i.wgg(_this__u8e3s4, $completion);
  l.$arity = 1;
  return l;
}
var GenericDialog$render$slambdaClass;
function GenericDialog$render$slambda() {
  if (GenericDialog$render$slambdaClass === VOID) {
    class $ {
      sao($completion) {
        get_dialogStack().ngd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    GenericDialog$render$slambdaClass = $;
  }
  return GenericDialog$render$slambdaClass;
}
function GenericDialog$render$slambda_0() {
  var i = new (GenericDialog$render$slambda())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var GenericDialog$render$slambdaClass_0;
function GenericDialog$render$slambda_1() {
  if (GenericDialog$render$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0, $$this$dismissBackground2) {
        this.uic_1 = this$0;
        this.vic_1 = $$this$dismissBackground2;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    GenericDialog$render$slambdaClass_0 = $;
  }
  return GenericDialog$render$slambdaClass_0;
}
function GenericDialog$render$slambda_2(this$0, $$this$dismissBackground2) {
  var i = new (GenericDialog$render$slambda_1())(this$0, $$this$dismissBackground2);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var GenericDialog$render$slambdaClass_1;
function GenericDialog$render$slambda_3() {
  if (GenericDialog$render$slambdaClass_1 === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.wic_1 = this$0;
        this.xic_1 = $$this$button;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    GenericDialog$render$slambdaClass_1 = $;
  }
  return GenericDialog$render$slambdaClass_1;
}
function GenericDialog$render$slambda_4(this$0, $$this$button) {
  var i = new (GenericDialog$render$slambda_3())(this$0, $$this$button);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var GenericDialogClass;
function GenericDialog() {
  if (GenericDialogClass === VOID) {
    class $ {
      static bgh(header, message, dismissText, dismiss) {
        dismissText = dismissText === VOID ? 'Close' : dismissText;
        var tmp;
        if (dismiss === VOID) {
          tmp = GenericDialog$_init_$slambda_w7jzu5_0();
        } else {
          tmp = dismiss;
        }
        dismiss = tmp;
        var $this = createThis(this);
        $this.xgg_1 = header;
        $this.ygg_1 = message;
        $this.zgg_1 = dismissText;
        $this.agh_1 = dismiss;
        return $this;
      }
      static zgy(message, dismiss) {
        var tmp;
        if (dismiss === VOID) {
          tmp = GenericDialog$_init_$slambda_w7jzu5_2();
        } else {
          tmp = dismiss;
        }
        dismiss = tmp;
        return this.bgh(null, message, 'Close', dismiss);
      }
      ud6(_this__u8e3s4) {
        // Inline function 'com.crowpay.views.components.dismissBackground2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (DismissBackground())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.tbo(GenericDialog$render$slambda_0());
        view.eba(get_AppDimensions().wg1_1);
        view.tbo(GenericDialog$render$slambda_2(this, view));
        var tmp = view.ibb(view.hbb(DialogSemantic_getInstance()), get_centered(view));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        view_0.eba(get_AppDimensions().wg1_1);
        var tmp0_maxWidth = get_rem(40);
        var tmp1_minWidth = get_rem(10);
        var tmp_0 = sizeConstraints(view_0, tmp1_minWidth, tmp0_maxWidth);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.ebb(p_1, view_1);
        view_1.xbm(true);
        var tmp0_safe_receiver = this.xgg_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          title(view_1, tmp0_safe_receiver);
        }
        // Inline function 'com.crowpay.views.theming.body' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (TextView())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.cbb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.ebb(p_2, view_2);
        view_2.jba(view_2.ob6_1.ybe(BodySemantic_getInstance()));
        view_2.acp(this.ygg_1);
        view_1.fbb(p_2, view_2);
        var tmp_1 = view_1.ibb(align(view_1, Align_Start_getInstance(), Align_Start_getInstance()), get_primaryButton(view_1));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (Button())(view_1.pc());
        var tmp0_elvis_lhs_3 = view_1.cbb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
        view_1.ebb(p_3, view_3);
        specCenteredText(view_3, this.zgg_1);
        onClick(view_3, 'Dismiss', VOID, GenericDialog$render$slambda_4(this, view_3));
        view_1.fbb(p_3, view_3);
        view_1.jbb(tmp_1, view_3);
        view_0.fbb(p_1, view_1);
        view_0.jbb(tmp_0, view_1);
        view.fbb(p_0, view_0);
        view.jbb(tmp, view_0);
        _this__u8e3s4.fbb(p, view);
        return view;
      }
    }
    protoOf($).ucv = get_title;
    initMetadataForClass($, 'GenericDialog', VOID, VOID, [Page()]);
    GenericDialogClass = $;
  }
  return GenericDialogClass;
}
var dialogView$slambdaClass;
function dialogView$slambda() {
  if (dialogView$slambdaClass === VOID) {
    class $ {
      sao($completion) {
        get_dialogStack().ngd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    dialogView$slambdaClass = $;
  }
  return dialogView$slambdaClass;
}
function dialogView$slambda_0() {
  var i = new (dialogView$slambda())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
//region block: exports
export {
  GenericDialog as GenericDialog2kroovzplfo3s,
  dialogView as dialogView37nkwa7nowbx3,
};
//endregion

//# sourceMappingURL=GenericDialog.mjs.map
